import React from 'react';
import { classes } from './DragHandleTableCell.st.css.js';
import { DragHandle } from './DragHandle';

export interface DragHandleTableCellProps {
  id: string | number;
}

export function DragHandleTableCell(props: DragHandleTableCellProps) {
  return (
    <div className={classes.root}>
      <DragHandle className={classes.trigger} {...props} />
    </div>
  );
}
